// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2wGyY","label":"LabeledBox_label__1TOX2"};